class RequestMonitor {
  _requests = {};

  check(request, uniqueKey) {
    request
      .then(() => {
        delete this._requests[uniqueKey];
      })
      .catch(() => {});

    if (uniqueKey in this._requests && this._requests) {
      this._requests[uniqueKey].abort();
      delete this._requests[uniqueKey];
    }

    this._requests[uniqueKey] = request;
  }
}

export default new RequestMonitor();
